import Cookies from 'js-cookie';

const MAX_ITEMS = 20;
let wishlistCookie = Cookies.get('wishlist-cookie');
let array = [];

if (wishlistCookie) {
    array = JSON.parse(wishlistCookie);
  
}

export function WishlistDrawing() {
    const existingIds = new Set(array.map(item => String(item.id)));

    document.querySelectorAll('[data-wishlist-id]').forEach(wishlistItem => {
        const pid = wishlistItem.getAttribute('data-wishlist-id');

        if (existingIds.has(pid)) {
            wishlistItem.classList.add('existing');
        } else {
            wishlistItem.classList.remove('existing');
        }
    });
}

export function WishlistBinding() {
    const wishlistLink = document.getElementById('wishlist-box');

    if (wishlistLink) {
        wishlistLink.setAttribute('data-wishlist-count', array.length);
    }

    document.querySelectorAll('[data-wishlist-id]').forEach(item => {
        item.addEventListener('click', function () {
            const pid = this.getAttribute('data-wishlist-id');

           

            const foundPid = array.find(arrayItem => Number(arrayItem.id) === Number(pid));

            if (foundPid) {
                let index;

                array.some(function (elem, i) {
                    return Number(elem.id) === Number(pid) ? (index = i, true) : false;
                });
                array.splice(index, 1);

            } else {

             

                if (array.length >= MAX_ITEMS) {
                    array.shift();
                }

                array.push({
                    id: pid,
                    date: Date.now()
                });

            }

            array.sort((a, b) => a.date - b.date);
            Cookies.set('wishlist-cookie', JSON.stringify(array), { expires: 30 });

            wishlistLink.setAttribute('data-wishlist-count', array.length);

            WishlistDrawing();
        });
    });


}